/** @jsx jsx */
import { jsx } from "theme-ui"
import { rem } from "@src/theme"

// Components
import Spacer from "@components/Spacers"
import Container from "@components/Container"
import Banner from "@components/Banner"

// Assets
import RainbowFlag from "@components/assets/svg/rainbowFlag.svg"
import RainbowHeart from "@components/assets/svg/rainbowHeart.svg"

const IconThreeUp = ({ textBlocks = [], heading = "" }) => (
  <div>
    <Container>
      {heading && (
        <div
          sx={{
            display: "flex",
            mt: 5,
          }}
        >
          <Banner title={heading} />
        </div>
      )}
      <Spacer.Medium />
      <div
        sx={{
          display: "flex",
          mx: "auto",
          justifyContent: "space-around",
          flexDirection: ["column", "row"],
        }}
      >
        {textBlocks.map((text, index) => (
          <div
            key={index}
            sx={{
              display: "flex",
              flexDirection: ["column", null, null, "row"],
              alignItems: ["center", null, null, "initial"],
              mb: [rem(70), 0, null, 0],
              px: [0, 2, null, 0],
            }}
          >
            {index === 0 ? <RainbowFlag /> : null}
            {index === 1 ? <RainbowHeart /> : null}
            {index === 2 ? <Rainbow100 /> : null}{" "}
            <p
              sx={{
                m: 0,
                mt: [rem(15), null, null, 0],
                ml: [0, null, null, rem(28)],
                maxWidth: textBlocks.length > 2 ? rem(230) : rem(400),
                textAlign: ["center", null, null, "left"],
              }}
            >
              {text}
            </p>
          </div>
        ))}
      </div>
    </Container>
    <Spacer.Medium />
  </div>
)

// Import the SVG directly because of the mask-type
// not working when it's in a file
const Rainbow100 = () => (
  <svg
    width="70"
    height="48"
    viewBox="0 0 70 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="rainbow100"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="5"
      width="70"
      height="38"
    >
      <path
        d="M1.1845 6.7422L0 15.066H3.94834L0 42.3605L9.87085 42.1669L15.0037 6.54862L1.1845 6.7422ZM41.2601 21.6477C41.2601 21.0669 41.2601 20.2926 41.2601 19.1312C41.2601 15.2596 40.2731 12.1624 38.6937 9.64586C36.7196 6.93578 33.9557 5.58073 30.2048 5.58073C25.8616 5.58073 22.3081 7.71009 19.7417 11.5816C17.5701 14.8725 16.1882 19.1312 15.3985 24.3578C15.2011 25.5192 15.2011 26.4871 15.2011 27.0678C15.2011 27.6486 15.2011 28.4229 15.2011 29.3908C15.2011 33.2623 15.9908 36.3596 17.5701 38.6825C19.3469 41.3926 22.1107 42.7476 25.6642 42.7476C30.0074 42.7476 33.7583 40.8119 36.5221 36.9403C38.8911 33.8431 40.2731 29.5844 41.0627 24.3578C41.2601 23.0027 41.2601 22.2284 41.2601 21.6477ZM29.4151 32.488C28.6255 33.8431 27.8358 34.6174 26.6513 34.6174C25.8616 34.6174 25.2694 34.2302 24.8745 33.4559C24.4797 32.6816 24.2823 31.7137 24.2823 30.3587C24.2823 29.7779 24.2823 28.6165 24.4797 27.2614C24.6771 25.9064 24.6771 24.9385 24.8745 24.1642C25.4668 20.4862 26.059 17.5825 27.0461 16.0339C27.8358 14.6789 28.6255 13.9046 29.6125 13.9046C30.4022 13.9046 30.9945 14.2917 31.3893 15.066C31.7841 15.8403 31.9816 16.8082 31.9816 18.1633C31.9816 19.1312 31.9816 19.9055 31.9816 20.6798C31.9816 21.4541 31.7841 22.6156 31.5867 23.777C30.9945 27.8422 30.4022 30.5522 29.4151 32.488ZM69.8856 21.0669C69.8856 20.4862 69.8856 19.7119 69.8856 18.5504C69.8856 14.6789 68.8985 11.5816 67.3192 9.06513C65.345 6.35504 62.5812 5 58.8303 5C54.4871 5 50.9336 7.12935 48.3672 11.0009C46.1956 14.2917 44.8137 18.3569 44.024 23.777C43.8266 24.9385 43.8266 25.9064 43.8266 26.4871C43.8266 27.0678 43.8266 27.8422 43.8266 28.81C43.8266 32.6816 44.6162 35.7788 46.1956 38.1018C47.9723 40.8118 50.7362 42.1669 54.2897 42.1669C58.6328 42.1669 62.3838 40.2311 65.1476 36.3596C67.5166 33.2623 68.8985 29.0036 69.6882 23.777C69.6882 22.6156 69.6882 21.6477 69.8856 21.0669ZM57.8432 31.9073C57.0535 33.2623 56.2638 34.0366 55.0793 34.0366C54.2897 34.0366 53.6974 33.6495 53.3026 32.8752C52.9078 32.1009 52.7103 31.133 52.7103 29.7779C52.7103 29.1972 52.7103 28.0357 52.9078 26.6807C53.1052 25.3256 53.1052 24.3578 53.3026 23.5834C53.8948 19.9055 54.4871 17.0018 55.4742 15.4532C56.4613 14.0981 57.2509 13.3238 58.238 13.3238C59.0277 13.3238 59.6199 13.711 60.0148 14.4853C60.4096 15.2596 60.607 16.2275 60.607 17.5825C60.607 18.5504 60.607 19.3247 60.607 20.099C60.607 20.8734 60.4096 22.0348 60.2122 23.1963C59.6199 27.2614 58.8303 30.1651 57.8432 31.9073Z"
        fill="#8C67AA"
      />
    </mask>
    <g mask="url(#rainbow100)">
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 3.64453)"
        fill="#F37361"
      />
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 10.1294)"
        fill="#F89B3C"
      />
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 16.6143)"
        fill="#FCDF5C"
      />
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 23.0991)"
        fill="#A3BB4A"
      />
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 29.584)"
        fill="#5BC7BE"
      />
      <rect
        width="6.48484"
        height="114.566"
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 -7.56641 36.0688)"
        fill="#6A5095"
      />
    </g>
    <path
      d="M3.15393 6.65827L2.03711 14.5065H5.75983L2.03711 40.2412L11.3439 40.0587L16.1834 6.47575L3.15393 6.65827ZM40.9395 20.712C40.9395 20.1645 40.9395 19.4344 40.9395 18.3393C40.9395 14.689 40.0089 11.7687 38.5198 9.39601C36.6584 6.84079 34.0525 5.56317 30.5159 5.56317C26.4209 5.56317 23.0705 7.57085 20.6507 11.2212C18.6032 14.3239 17.3003 18.3393 16.5557 23.2672C16.3696 24.3623 16.3696 25.2749 16.3696 25.8225C16.3696 26.37 16.3696 27.1001 16.3696 28.0126C16.3696 31.663 17.1141 34.5832 18.6032 36.7734C20.2784 39.3286 22.8843 40.6062 26.2348 40.6062C30.3298 40.6062 33.8664 38.7811 36.4723 35.1308C38.7059 32.2105 40.0089 28.1952 40.7534 23.2672C40.9395 21.9896 40.9395 21.2595 40.9395 20.712ZM29.7714 30.9329C29.0268 32.2105 28.2823 32.9406 27.1655 32.9406C26.4209 32.9406 25.8625 32.5755 25.4902 31.8455C25.118 31.1154 24.9318 30.2028 24.9318 28.9252C24.9318 28.3777 24.9318 27.2826 25.118 26.005C25.3041 24.7274 25.3041 23.8148 25.4902 23.0847C26.0487 19.6169 26.6071 16.8792 27.5377 15.419C28.2823 14.1414 29.0268 13.4114 29.9575 13.4114C30.7021 13.4114 31.2605 13.7764 31.6327 14.5065C32.005 15.2365 32.1911 16.1491 32.1911 17.4267C32.1911 18.3393 32.1911 19.0694 32.1911 19.7994C32.1911 20.5295 32.005 21.6246 31.8189 22.7197C31.2605 26.5525 30.7021 29.1077 29.7714 30.9329ZM67.9293 20.1645C67.9293 19.6169 67.9293 18.8868 67.9293 17.7917C67.9293 14.1414 66.9986 11.2212 65.5095 8.84846C63.6481 6.29324 61.0422 5.01562 57.5056 5.01562C53.4106 5.01562 50.0602 7.0233 47.6404 10.6736C45.5929 13.7764 44.29 17.6092 43.5454 22.7197C43.3593 23.8148 43.3593 24.7274 43.3593 25.2749C43.3593 25.8225 43.3593 26.5525 43.3593 27.4651C43.3593 31.1154 44.1038 34.0357 45.5929 36.2259C47.2682 38.7811 49.8741 40.0587 53.2245 40.0587C57.3195 40.0587 60.8561 38.2335 63.462 34.5832C65.6956 31.663 66.9986 27.6476 67.7431 22.7197C67.7431 21.6246 67.7431 20.712 67.9293 20.1645ZM56.575 30.3854C55.8304 31.663 55.0859 32.393 53.9691 32.393C53.2245 32.393 52.6661 32.028 52.2938 31.2979C51.9216 30.5679 51.7354 29.6553 51.7354 28.3777C51.7354 27.8301 51.7354 26.735 51.9216 25.4574C52.1077 24.1798 52.1077 23.2672 52.2938 22.5372C52.8522 19.0694 53.4106 16.3316 54.3413 14.8715C55.272 13.5939 56.0165 12.8638 56.9472 12.8638C57.6918 12.8638 58.2502 13.2288 58.6225 13.9589C58.9947 14.689 59.1809 15.6016 59.1809 16.8792C59.1809 17.7917 59.1809 18.5218 59.1809 19.2519C59.1809 19.9819 58.9947 21.077 58.8086 22.1721C58.2502 26.005 57.5056 28.7427 56.575 30.3854Z"
      stroke="black"
      strokeWidth="2.0381"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconThreeUp
